export const locale = {
    lang: "es",
    data: {
        MYQUOTES: {
            MYQUOTES: "Mis Cotizaciones",
        },
    },
};
